import { Link } from "react-router-dom";
import { MapPin, Mail, MessageCircle } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="relative mt-32 bg-foreground text-background"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-2 mb-6">
                            <div className="w-9 h-9 rounded-lg bg-background text-foreground grid place-items-center font-display font-bold">
                                T
                            </div>
                            <span className="font-display text-xl">
                                Thooyra Technologies
                            </span>
                        </div>
                        <p className="text-background/70 max-w-md leading-relaxed">
                            Building modern business software with calm
                            engineering and elegant user experiences. From
                            Chennai, for the world.
                        </p>
                        {/* Social links will be enabled once Thooyra's social pages are live */}
                        <div className="flex items-center gap-3 mt-8">
                            <a
                                href="mailto:support@thooyra.in"
                                data-testid="footer-cta-email"
                                className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background/20 text-sm hover:bg-background hover:text-foreground transition-colors"
                            >
                                <Mail className="h-4 w-4" />
                                support@thooyra.in
                            </a>
                            <a
                                href="https://wa.me/917975511832"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-cta-whatsapp"
                                className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background/20 text-sm hover:bg-background hover:text-foreground transition-colors"
                            >
                                <MessageCircle className="h-4 w-4" />
                                WhatsApp
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="text-sm uppercase tracking-widest text-background/50 mb-5">
                            Explore
                        </h4>
                        <ul className="space-y-3">
                            {[
                                { to: "/services", label: "Services" },
                                { to: "/portfolio", label: "Work" },
                                { to: "/about", label: "About" },
                                { to: "/careers", label: "Careers" },
                                { to: "/contact", label: "Contact" },
                            ].map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-link-${l.label.toLowerCase()}`}
                                        className="text-background/80 hover:text-background transition-colors"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <h4 className="text-sm uppercase tracking-widest text-background/50 mb-5">
                            Contact
                        </h4>
                        <ul className="space-y-4 text-background/80">
                            <li className="flex items-start gap-3">
                                <MapPin className="h-4 w-4 mt-1 text-background/60" />
                                Chennai, Tamil Nadu, India
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail className="h-4 w-4 mt-1 text-background/60" />
                                <a
                                    href="mailto:support@thooyra.in"
                                    data-testid="footer-email"
                                    className="hover:text-background"
                                >
                                    support@thooyra.in
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MessageCircle className="h-4 w-4 mt-1 text-background/60" />
                                <a
                                    href="https://wa.me/917975511832"
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="footer-whatsapp"
                                    className="hover:text-background"
                                >
                                    +91 79755 11832
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-background/10 flex flex-col md:flex-row gap-4 items-center justify-between text-sm text-background/50">
                    <div>
                        © {new Date().getFullYear()} Thooyra Technologies ·
                        thooyra.in
                    </div>
                    <div className="flex items-center gap-6">
                        <span>Made calmly in Chennai</span>
                    </div>
                </div>
            </div>

            <div
                aria-hidden
                className="absolute inset-x-0 bottom-0 overflow-hidden pointer-events-none select-none"
            >
                <div className="font-display text-[18vw] leading-none text-background/[0.04] whitespace-nowrap text-center -mb-10">
                    THOOYRA
                </div>
            </div>
        </footer>
    );
}
